import { render, staticRenderFns } from "./PersistSocialTypeView.vue?vue&type=template&id=4d145a6c&scoped=true"
import script from "./PersistSocialTypeView.vue?vue&type=script&lang=ts"
export * from "./PersistSocialTypeView.vue?vue&type=script&lang=ts"
import style0 from "./PersistSocialTypeView.vue?vue&type=style&index=0&id=4d145a6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d145a6c",
  null
  
)

export default component.exports